import { PermissionsUser } from 'src/pages/LoginSaff';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  permissions: PermissionsUser | null;
  nameEn: string | null; // Add a nameEn field
  userId: number | null; // Add userId field
  isSaff: boolean;
  isClub: boolean; // Add isClub field to detect club users
  setToken: (token: string) => void;
  setPermissions: (permissions: PermissionsUser, nameEn: string, userId?: number, isClub?: boolean) => void; // Update the method to accept isClub
  clearToken: () => void;
}

export const useAuthStore = create(persist<AuthState>(
  (set) => ({
    token: '', // Initialize token, can be null or empty
    permissions: null, // Initialize permissions as null
    nameEn: null, // Initialize nameEn as null
    userId: null, // Initialize userId as null
    isSaff: false, // Initialize isSaff as false
    isClub: true, // Initialize isClub as false
    setToken: (token: string) => set({ token }), // Setter for token
    setPermissions: (permissions: PermissionsUser, nameEn: string, userId?: number, isClub?: boolean) => set({ 
      permissions, 
      nameEn, // Set the nameEn field
      userId: userId || null, // Set the userId field
      isSaff: permissions?.is_saff ?? false, // Calculate and set isSaff
      isClub: isClub ?? false // Set isClub field
    }), 
    clearToken: () => set({ token: null, permissions: null, nameEn: null, userId: null, isSaff: false, isClub: false }), // Clear token, permissions, nameEn, userId, and reset isSaff and isClub
  }),
  {
    name: 'auth-storage', // Name for localStorage key
    getStorage: () => localStorage, // Define localStorage as the storage type
  }
));
